module.exports = __webpack_public_path__ + "media/images/iguana-02d59bd117801629eb14056f264386b1.png";